import React from 'react';
import {connect} from 'react-redux';
import {
    activateLayer,
    changeLayerOpacity,
    displayRestoreLayerPopup,
    loadLayers, toggleMobileMenu,
    updateMapProperties
} from '../../../actions';
import NavbarLayerItem from './NavbarLayerItem';
import self from '../../../apis/self';
import {Base64} from 'js-base64';
import Cookies from 'universal-cookie';
import {isJSON} from '../../../config/dynamicUrlHelper';
import {Mobile} from '../Responsive';
import {ReactSVG} from 'react-svg';
/**
 * Layers container on Navbar
 */
class NavbarLayerList extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        if (this.props.layers.length === 0) {
            this.getLayers();
        }
    }

    /**
     * get layer list from API
     *
     * @returns {Promise<void>}
     */
    getLayers = async () => {
        const response = await self.get('/layers', {
            timeout: 40000
        });
        if (response) {
            let layerGroups = response.data;
            layerGroups.forEach(layerGroup => {
                layerGroup.layers.forEach(layer => {
                    /*setup is radio*/
                    if(layerGroup.mode == 'radio'){
                        layer.is_radio = true;
                    }
                    /* setup default opacity */
                    if(!layer.opacity){
                        layer.opacity = 100;
                    }
                    /* setup default checked layer */
                    if(layer.layer_active) {
                        layer.layer_active.layer_lists.forEach(layer_item => {
                            if (layer_item.is_default === 1) {
                                layer_item.is_active = true;
                            }
                        });
                    }
                })
            });

            this.props.loadLayers(layerGroups);

            /* process dynamic url */
            if(window.queryUrl) {
                const dynamicUrlJsonString = Base64.decode(window.queryUrl);
                this.processDynamicUrl(dynamicUrlJsonString)

                window.queryUrlLoaded = 1;
            } else {
                /* check if cookies available */
                const cookies = new Cookies();
                if (cookies.get('prims_dynamic_url')) {
                    this.props.displayRestoreLayerPopup({status: true});
                } else {
                    window.queryUrlLoaded = 1;
                    this.props.layers.map(layerGroup => {
                        layerGroup.layers.map(layer => {
                            if (layer.is_default) {
                                this.props.activateLayer(layer);
                            }
                        });
                    });
                }
            }
        } else {
            //TODO: ERROR HANDLING ON GET LAYERS
            console.log('getLayers failed');
            console.log(response);
        }
    }

    /**
     * process dynamic url
     *
     * @param dynamicUrlJsonString
     */
    processDynamicUrl(dynamicUrlJsonString) {
        if (isJSON(dynamicUrlJsonString)) {
            const dynamicUrlObj = JSON.parse(dynamicUrlJsonString);
            dynamicUrlObj.layers.reverse();
            dynamicUrlObj.layers.forEach((prevLayer) => {
                this.props.layers.forEach(layerGroup => {
                    const newLayer = layerGroup.layers.find(layer => {
                        if (layer.id === prevLayer.id) {
                            layer.opacity = prevLayer.opacity;
                            layer.hide = prevLayer.hide;
                            layer.layer_active.layer_time = prevLayer.layer_time;
                            prevLayer.subLayers.forEach((prevSubLayer, index) => {
                                if (prevSubLayer.id === layer.layer_active.layer_lists[index].id) {
                                    layer.layer_active.layer_lists[index].is_active = prevSubLayer.is_active;
                                }
                            });
                            return layer;
                        }
                    });
                    if (newLayer) {
                        this.props.activateLayer(newLayer);
                    }
                });
            });
            this.props.updateMapProperties(dynamicUrlObj.mapProperties);
        } else {
            this.displayDefaultLayer();
        }
    }

    /**
     * display default layer
     */
    displayDefaultLayer() {
        window.queryUrlLoaded = 1;
        this.props.layers.map(layerGroup => {
            layerGroup.layers.map(layer => {
                if (layer.is_default) {
                    this.props.activateLayer(layer);
                }
            });
        });
    }
    /**
     * render layer list to jsx
     */
    renderLayerList() {
        return this.props.layers.map(layerGroup => {
            return (
                <li className="nav-item dropdown" key={layerGroup.id}>
                    <a className="nav-link dropdown-toggle" href="#" role="button" data-toggle="dropdown">
                        <span>{layerGroup.title}</span>
                        <Mobile>
                            <ReactSVG className="chevron-icon react-svg"
                                      src="/img/maps/icon/chevron.svg"/>
                        </Mobile>
                    </a>
                    <div className="dropdown-menu">
                        {
                            layerGroup.layers.map(layer => {
                                return (
                                    <NavbarLayerItem type={layerGroup.mode === 'radio' ? 'radio' : 'checkbox' } title={layer.title} key={layer.id} layer={layer}/>
                                );
                            })
                        }
                    </div>
                </li>
            );
        });
    }

    render() {
        return (
            <div
                className={`collapse navbar-collapse dropdown mobile-menu-panel keep-open ${this.props.mobileMenu === 'layers' ? 'show' : ''}`}
                id="navbar-layer-collapse">
                <Mobile>
                    <div className="mobile-panel-header">
                        <div className="wrapper">
                            <div className="title">
                                <ReactSVG className="location-finder-icon react-svg"
                                          src="/img/maps/icon/layers-2.svg"/>
                                <div>Layer</div>
                            </div>
                            <div>
                                <a className="btn btn-close" href="#" role="button"
                                   onClick={() => this.props.toggleMobileMenu({item: 'layers'})}
                                >
                                    <ReactSVG className="close-icon react-svg" src="/img/maps/icon/close.svg"/>
                                </a>
                            </div>
                        </div>
                    </div>
                </Mobile>
                <ul className="navbar-nav" id="navbar-layer">
                    {this.renderLayerList()}
                </ul>
            </div>
        );
    }
}

const mapActionToProps = {
    loadLayers,
    activateLayer,
    changeLayerOpacity,
    updateMapProperties,
    displayRestoreLayerPopup,
    toggleMobileMenu,
};

const mapStateToProps = state => {
    return {
        layers      : state.layers,
        activeLayers: state.activeLayers,
        mobileMenu  : state.mobileMenu,
    };
};

export default connect(mapStateToProps, mapActionToProps)(NavbarLayerList);